// extracted by mini-css-extract-plugin
export default {"menuItem":"AsideMenuItem_menuItem__Pfz3+","active":"AsideMenuItem_active__Iabp+","itemContent":"AsideMenuItem_itemContent__vQHsT","itemText":"AsideMenuItem_itemText__kTfdh"};